var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSatellit = function SvgSatellit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 14 14",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.896 1.3c-.8-.8-2-1.3-3.2-1.3v.8c2 0 3.7 1.6 3.7 3.7h.8c0-1.2-.4-2.3-1.3-3.2m-1.1 1.2c-.5-.5-1.3-.8-2-.8v.8c1.1 0 2 .9 2 2h.8c0-.8-.3-1.5-.8-2m-3.2 3.8.6-.6c.6.3 1.3 0 1.6-.6s0-1.3-.6-1.6-1.3 0-1.6.6c-.2.3-.2.7 0 1.1l-.6.5-3.5-3.5-.3.4c-1.4 2-1.3 4.6.2 6.4 1.8 2.2 4.9 2.6 7.2 1l.4-.3zm-1 6.9-.2-1.5c-1.2-.2-2.3-.8-3.2-1.7l-.6 3.1h-1.7v.9h7.4v-.8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSatellit);
export default ForwardRef;